module.exports = __webpack_public_path__ + "static/media/right-arrow.c9df718c.svg";